
const state = {
  id: null,
  brand_id: undefined,
  title: '',
}

export const requiredFields = [
  { key: 'brand_id' },
  { key: 'title' },
]

export default state
